import { render } from "./TermsAuth.vue?vue&type=template&id=344c0b42&scoped=true"
import script from "./TermsAuth.vue?vue&type=script&lang=js"
export * from "./TermsAuth.vue?vue&type=script&lang=js"

import "./TermsAuth.vue?vue&type=style&index=0&id=344c0b42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-344c0b42"

export default script